// extracted by mini-css-extract-plugin
export default {"searchInput":"navbar__searchInput__DI6tx","focus":"navbar__focus__dycNh"};